import { GetDataCommentReplySummary } from '@frontend/sorghum/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { COMMENT_REPLY_DATA_SUMMARY } from '../apis';

async function getGetDataCommentReplySummary(): Promise<GetDataCommentReplySummary> {
  return axios.get(COMMENT_REPLY_DATA_SUMMARY).then((res) => res.data.data);
}

export function useGetDataCommentReplySummary() {
  return useQuery<GetDataCommentReplySummary>({
    queryKey: ['get-data-comment-reply-summary'],
    // 失敗時不再回全 0 的假資料（會被誤讀成「沒有成效」），也不丟全域 error boundary；
    // 呼叫端用 isError 提示
    useErrorBoundary: false,
    // 只在失敗狀態下不要於視窗 focus 重打（這支 API 在大專案曾跑 30–60 秒，重打只會放大 rum 負載並重複跳 toast）；
    // 成功的資料仍照預設 staleTime 在 focus 時更新，維持「即時數據」
    refetchOnWindowFocus: (query) => query.state.status !== 'error',
    queryFn: () => getGetDataCommentReplySummary(),
  });
}

export default useGetDataCommentReplySummary;
